// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* src/components/Header.css */

  .sticky-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: #fff;
    border-bottom: 1px solid #ccc;
    opacity: .95;
  }

  .navbar {
    margin-bottom: 5px;
    padding: 0;
    font-size: 14px;
  }

  .logo {
    max-height: 40px;
    width: auto;
  }

  .navbar-collapse .welcome-message {
    text-align: right;
  }

  .nav-link,
  .nav-item .nav-link,
  .nav-link.btn {
    color: #666 !important; 
  }

  .navbar-nav {
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }

  .nav-link.active,
  .nav-item .nav-link.active,
  .nav-link.btn.active {
    color: #E3B620 !important; 
  }

  .nav-icons {
    display: flex;
    align-items: center;
    font-size: 1.1rem;
  }

  .icon-group {
    padding-left: 30px;
    position: relative;
  }

  .form-inline {
    display: flex;
    align-items: center;
    min-width: 100%;
    max-width: 1000px;
    position: relative;
  }

  .form-control {
    margin-top: 5px;
    font-size: 14px;
    font-weight: 300;
  }

  .search-form .btn {
    position: absolute;
    bottom: 5px;
    right: 5px;
    background: none;
    border: none;
    padding: 0;
    font-size: 1rem;
    color: dimgray;
  }

  .search-form input.form-control {
    padding-left: 5px;
    padding-right: 25px;
    font-size: 14px;
  }

  .popover-search {
    position: absolute;
    top: 40px;
    right: 0;
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    z-index: 100;
    width: max-content;
    max-width: 200px;
    color: black;
    font-size: 14px;
  }

  .form-control:active, .form-control:focus{
    border: 1px solid #FDE29C;
    box-shadow: none;
    outline: none;
  }

  @keyframes pulse {

    0% {
      transform: scale(1);
      box-shadow: 0 0 0 rgba(227, 182, 32, 0.7);
    }

    50% {
      transform: scale(1.1);
      box-shadow: 0 0 10px rgba(227, 182, 32, 0.7);
    }

    100% {
      transform: scale(1);
      box-shadow: 0 0 0 rgba(227, 182, 32, 0.7);
    }

  }

  /* Apply the pulsating effect when the music is playing */
  .nav-icons .btn.music-active {
    animation: pulse 1.5s infinite;
  }

  /* General reset for buttons */
  .nav-icons button {
    border: none; 
    background: none; 
    box-shadow: none; 
    outline: none; 
    cursor: pointer; 
  }

  .nav-icons button:focus,
  .nav-icons button:active {
    outline: none; 
    box-shadow: none; 
  }

  .nav-link.btn:active, .nav-link.btn:focus {
    outline: none; 
    box-shadow: none; 
  }

  .badge-count {
    position: absolute;
    top: 0px;
    right: -8px;
    background-color: tomato;
    color: white;
    border-radius: 50%;
    padding: 1px 5px 3px 5px;
    font-size: 8px;
    line-height: 1;
  }

  .count-zero {
    background-color: #999 !important;
  }

  .navbar-nav .nav-item .nav-link.btn {
    transition: color 0.2s ease;
  }

  .success-message {
    color: green;
    margin-top: 10px;
  }

  .error-message {
    color: red;
    margin-top: 10px;
  }

  /* Navbar Toggler Animation */
  .navbar-toggler svg {
    transition: all 0.3s ease;
  }

  .navbar-toggler .line1,
  .navbar-toggler .line2,
  .navbar-toggler .line3 {
    transition: transform 0.3s ease;
    transform-origin: center;
  }

  .navbar-toggler.active .line1 {
    transform: translateX(-6px) translateY(5px) rotate(50deg);
  }

  .navbar-toggler.active .line2 {
    opacity: 0;
  }

  .navbar-toggler.active .line3 {
    transform: translateX(-6px) translateY(-5px) rotate(-50deg);
  }

  /* Ensure the toggler button keeps its shape and border */
  .navbar-toggler {
    padding: 5px;
    padding-right: 5px;
    border: 1px solid darkgrey; 
  }

  .navbar-toggler:focus,
  .navbar-toggler:active {
    border: 1px solid darkgrey;
    box-shadow: none; 
    outline: none; 
  }

  @media (min-width: 768px) {

    .logo {
      max-height: 50px;
    }

    .navbar-nav {
      font-size: 1rem;
    }

    .icon-group {
      padding-left: 15px;
    }

    .nav-icons {
      font-size: 1.2rem;
    }

    .badge-count {
      top: -1px;
      right: -8px;
      font-size: 9px;
    }

  }

  @media (max-width: 991.98px) {

    .navbar-nav {
      flex-direction: column;
      align-items: flex-end;
      width: 100%;
    }

    .nav-icons {
      width: 100%;
      justify-content: space-between;
      margin-top: 9px;
    }

  }

  @media (min-width: 992px) {

    .navbar {
      font-size: 1.2rem;
    }

    .navbar-nav {
      padding-left: 15px;
    }

    .nav-icons {
      font-size: 1.1rem;
    }

    .icon-group {
      padding-left: 18px;
    }

    .badge-count {
      top: 1px;
      right: -4px;
    }

  }

  @media (min-width: 1200px) {

    .navbar-nav {
      padding-left: 80px;
    }

    .icon-group {
      padding-left: 15px;
    }

  }

  @media (min-width: 1400px) {
    
    .icon-group {
      padding-left: 35px;
    }

  }
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"EAAE,8BAA8B;;EAE9B;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,8BAA8B;EAChC;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,uCAAuC;IACvC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;EACf;;EAEA;;IAEE;MACE,mBAAmB;MACnB,yCAAyC;IAC3C;;IAEA;MACE,qBAAqB;MACrB,4CAA4C;IAC9C;;IAEA;MACE,mBAAmB;MACnB,yCAAyC;IAC3C;;EAEF;;EAEA,yDAAyD;EACzD;IACE,8BAA8B;EAChC;;EAEA,8BAA8B;EAC9B;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA,6BAA6B;EAC7B;IACE,yBAAyB;EAC3B;;EAEA;;;IAGE,+BAA+B;IAC/B,wBAAwB;EAC1B;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,2DAA2D;EAC7D;;EAEA,yDAAyD;EACzD;IACE,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,gBAAgB;IAChB,aAAa;EACf;;EAEA;;IAEE;MACE,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,SAAS;MACT,WAAW;MACX,cAAc;IAChB;;EAEF;;EAEA;;IAEE;MACE,sBAAsB;MACtB,qBAAqB;MACrB,WAAW;IACb;;IAEA;MACE,WAAW;MACX,8BAA8B;MAC9B,eAAe;IACjB;;EAEF;;EAEA;;IAEE;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,QAAQ;MACR,WAAW;IACb;;EAEF;;EAEA;;IAEE;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;EAEF;;EAEA;;IAEE;MACE,kBAAkB;IACpB;;EAEF","sourcesContent":["  /* src/components/Header.css */\r\n\r\n  .sticky-header {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1000;\r\n    background-color: #fff;\r\n    border-bottom: 1px solid #ccc;\r\n    opacity: .95;\r\n  }\r\n\r\n  .navbar {\r\n    margin-bottom: 5px;\r\n    padding: 0;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .logo {\r\n    max-height: 40px;\r\n    width: auto;\r\n  }\r\n\r\n  .navbar-collapse .welcome-message {\r\n    text-align: right;\r\n  }\r\n\r\n  .nav-link,\r\n  .nav-item .nav-link,\r\n  .nav-link.btn {\r\n    color: #666 !important; \r\n  }\r\n\r\n  .navbar-nav {\r\n    align-items: center;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .nav-link.active,\r\n  .nav-item .nav-link.active,\r\n  .nav-link.btn.active {\r\n    color: #E3B620 !important; \r\n  }\r\n\r\n  .nav-icons {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .icon-group {\r\n    padding-left: 30px;\r\n    position: relative;\r\n  }\r\n\r\n  .form-inline {\r\n    display: flex;\r\n    align-items: center;\r\n    min-width: 100%;\r\n    max-width: 1000px;\r\n    position: relative;\r\n  }\r\n\r\n  .form-control {\r\n    margin-top: 5px;\r\n    font-size: 14px;\r\n    font-weight: 300;\r\n  }\r\n\r\n  .search-form .btn {\r\n    position: absolute;\r\n    bottom: 5px;\r\n    right: 5px;\r\n    background: none;\r\n    border: none;\r\n    padding: 0;\r\n    font-size: 1rem;\r\n    color: dimgray;\r\n  }\r\n\r\n  .search-form input.form-control {\r\n    padding-left: 5px;\r\n    padding-right: 25px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .popover-search {\r\n    position: absolute;\r\n    top: 40px;\r\n    right: 0;\r\n    background-color: #fff;\r\n    border: 1px solid #ccc;\r\n    padding: 5px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    z-index: 100;\r\n    width: max-content;\r\n    max-width: 200px;\r\n    color: black;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .form-control:active, .form-control:focus{\r\n    border: 1px solid #FDE29C;\r\n    box-shadow: none;\r\n    outline: none;\r\n  }\r\n\r\n  @keyframes pulse {\r\n\r\n    0% {\r\n      transform: scale(1);\r\n      box-shadow: 0 0 0 rgba(227, 182, 32, 0.7);\r\n    }\r\n\r\n    50% {\r\n      transform: scale(1.1);\r\n      box-shadow: 0 0 10px rgba(227, 182, 32, 0.7);\r\n    }\r\n\r\n    100% {\r\n      transform: scale(1);\r\n      box-shadow: 0 0 0 rgba(227, 182, 32, 0.7);\r\n    }\r\n\r\n  }\r\n\r\n  /* Apply the pulsating effect when the music is playing */\r\n  .nav-icons .btn.music-active {\r\n    animation: pulse 1.5s infinite;\r\n  }\r\n\r\n  /* General reset for buttons */\r\n  .nav-icons button {\r\n    border: none; \r\n    background: none; \r\n    box-shadow: none; \r\n    outline: none; \r\n    cursor: pointer; \r\n  }\r\n\r\n  .nav-icons button:focus,\r\n  .nav-icons button:active {\r\n    outline: none; \r\n    box-shadow: none; \r\n  }\r\n\r\n  .nav-link.btn:active, .nav-link.btn:focus {\r\n    outline: none; \r\n    box-shadow: none; \r\n  }\r\n\r\n  .badge-count {\r\n    position: absolute;\r\n    top: 0px;\r\n    right: -8px;\r\n    background-color: tomato;\r\n    color: white;\r\n    border-radius: 50%;\r\n    padding: 1px 5px 3px 5px;\r\n    font-size: 8px;\r\n    line-height: 1;\r\n  }\r\n\r\n  .count-zero {\r\n    background-color: #999 !important;\r\n  }\r\n\r\n  .navbar-nav .nav-item .nav-link.btn {\r\n    transition: color 0.2s ease;\r\n  }\r\n\r\n  .success-message {\r\n    color: green;\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .error-message {\r\n    color: red;\r\n    margin-top: 10px;\r\n  }\r\n\r\n  /* Navbar Toggler Animation */\r\n  .navbar-toggler svg {\r\n    transition: all 0.3s ease;\r\n  }\r\n\r\n  .navbar-toggler .line1,\r\n  .navbar-toggler .line2,\r\n  .navbar-toggler .line3 {\r\n    transition: transform 0.3s ease;\r\n    transform-origin: center;\r\n  }\r\n\r\n  .navbar-toggler.active .line1 {\r\n    transform: translateX(-6px) translateY(5px) rotate(50deg);\r\n  }\r\n\r\n  .navbar-toggler.active .line2 {\r\n    opacity: 0;\r\n  }\r\n\r\n  .navbar-toggler.active .line3 {\r\n    transform: translateX(-6px) translateY(-5px) rotate(-50deg);\r\n  }\r\n\r\n  /* Ensure the toggler button keeps its shape and border */\r\n  .navbar-toggler {\r\n    padding: 5px;\r\n    padding-right: 5px;\r\n    border: 1px solid darkgrey; \r\n  }\r\n\r\n  .navbar-toggler:focus,\r\n  .navbar-toggler:active {\r\n    border: 1px solid darkgrey;\r\n    box-shadow: none; \r\n    outline: none; \r\n  }\r\n\r\n  @media (min-width: 768px) {\r\n\r\n    .logo {\r\n      max-height: 50px;\r\n    }\r\n\r\n    .navbar-nav {\r\n      font-size: 1rem;\r\n    }\r\n\r\n    .icon-group {\r\n      padding-left: 15px;\r\n    }\r\n\r\n    .nav-icons {\r\n      font-size: 1.2rem;\r\n    }\r\n\r\n    .badge-count {\r\n      top: -1px;\r\n      right: -8px;\r\n      font-size: 9px;\r\n    }\r\n\r\n  }\r\n\r\n  @media (max-width: 991.98px) {\r\n\r\n    .navbar-nav {\r\n      flex-direction: column;\r\n      align-items: flex-end;\r\n      width: 100%;\r\n    }\r\n\r\n    .nav-icons {\r\n      width: 100%;\r\n      justify-content: space-between;\r\n      margin-top: 9px;\r\n    }\r\n\r\n  }\r\n\r\n  @media (min-width: 992px) {\r\n\r\n    .navbar {\r\n      font-size: 1.2rem;\r\n    }\r\n\r\n    .navbar-nav {\r\n      padding-left: 15px;\r\n    }\r\n\r\n    .nav-icons {\r\n      font-size: 1.1rem;\r\n    }\r\n\r\n    .icon-group {\r\n      padding-left: 18px;\r\n    }\r\n\r\n    .badge-count {\r\n      top: 1px;\r\n      right: -4px;\r\n    }\r\n\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n\r\n    .navbar-nav {\r\n      padding-left: 80px;\r\n    }\r\n\r\n    .icon-group {\r\n      padding-left: 15px;\r\n    }\r\n\r\n  }\r\n\r\n  @media (min-width: 1400px) {\r\n    \r\n    .icon-group {\r\n      padding-left: 35px;\r\n    }\r\n\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
